import { render, staticRenderFns } from "./iconUserPosition.vue?vue&type=template&id=023619b8&"
import script from "./iconUserPosition.vue?vue&type=script&lang=js&"
export * from "./iconUserPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports